import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class ConnectService {

  public show;
  public showConnect () {
    return this.show;
  }
  public submit (form) {
    // console.log(form);
    return this.http.post('/contact', form)
      .subscribe(res => {
        // console.log("submit: ", res);
          return true;
        }, (err) => {
          console.error(err);
        }
      );
  }

  public toggleConnect = (toggle:boolean) => {
    // console.log("toggleConnect: ", toggle);
    this.show = toggle;
  }



  constructor(private http: HttpClient) { }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/connect.service.ts